import { Building2, CheckCircle2, Sofa, Home } from "lucide-react";

export const STATUS_META = {
  not_assigned: { label: "Not Assigned", color: "#71717A", bg: "#F4F4F5" },
  assigned: { label: "Assigned", color: "#2563EB", bg: "#EFF6FF" },
  in_progress: { label: "In Progress", color: "#D97706", bg: "#FFFBEB" },
  completed: { label: "Completed", color: "#059669", bg: "#ECFDF5" },
  for_review: { label: "For Review", color: "#7C3AED", bg: "#F5F3FF" },
  update_requested: { label: "Update Requested", color: "#EA580C", bg: "#FFF7ED" },
  checking: { label: "Checking", color: "#E11D48", bg: "#FFF1F2" },
};

export const STATUS_ORDER = ["not_assigned", "assigned", "in_progress", "checking", "for_review", "update_requested", "completed"];

export const PRIORITY_META = {
  none: { label: "None", color: "#A1A1AA" },
  low: { label: "Low", color: "#3B82F6" },
  medium: { label: "Medium", color: "#D97706" },
  high: { label: "High", color: "#EA580C" },
  urgent: { label: "Urgent", color: "#DC2626" },
};

export const CATEGORY_META = {
  architecture_current: { label: "Architecture", sub: "Current", icon: Building2 },
  architecture_completed: { label: "Architecture", sub: "Completed", icon: CheckCircle2 },
  interior_current: { label: "Interior", sub: "Current", icon: Sofa },
  interior_completed: { label: "Interior", sub: "Completed", icon: Home },
};

export const CATEGORY_ORDER = [
  "architecture_current",
  "architecture_completed",
  "interior_current",
  "interior_completed",
];

const PALETTE = ["#18181B", "#2563EB", "#059669", "#D97706", "#7C3AED", "#E11D48", "#0891B2", "#DB2777"];
export function colorForId(id) {
  if (!id) return PALETTE[0];
  let h = 0;
  for (let i = 0; i < id.length; i++) h = id.charCodeAt(i) + ((h << 5) - h);
  return PALETTE[Math.abs(h) % PALETTE.length];
}
export function initials(name) {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  return (parts[0][0] + (parts[1] ? parts[1][0] : "")).toUpperCase();
}
export function fmtDate(d) {
  if (!d) return "—";
  const dt = new Date(d + "T00:00:00");
  if (isNaN(dt)) return d;
  const dd = String(dt.getDate()).padStart(2, "0");
  const mm = String(dt.getMonth() + 1).padStart(2, "0");
  const yy = String(dt.getFullYear()).slice(2);
  return `${dd}/${mm}/${yy}`;
}

export function todayStr() {
  // Anchor "today" to Sydney regardless of the viewer's device timezone (en-CA => YYYY-MM-DD).
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: "Australia/Sydney", year: "numeric", month: "2-digit", day: "2-digit",
  }).format(new Date());
}
export function isOverdue(task) {
  const ed = task?.end_date;
  return !!ed && ed < todayStr() && task?.status !== "completed";
}
